import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";

export default function Index({ link, accent, text }) {
  return (
    <Link
      to={link}
      className={`btn ${accent ? "accent-btn" : "primary-btn"}`}
    >
      {text}
    </Link>
  );
}
